var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavFinanzasWhite = function SvgNavFinanzasWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_finanzas_white_svg__Capa_2",
    viewBox: "0 0 33.94 33.94"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_finanzas_white_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.22,
    cy: 17.27,
    r: 12.86,
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.32 11.5c.54-.27 1.21-.38 1.9-.4v4.64c-2.04-.43-3.29-.94-3.15-2.33.09-.92.5-1.54 1.25-1.91m3.4 6.07v5.01c.66-.01 1.28-.11 1.79-.34.79-.36 1.23-1.01 1.35-1.98.18-1.57-.96-2.21-3.14-2.69m16.22-3.88v6.57c0 7.55-6.14 13.69-13.69 13.69h-6.57c-7.55 0-13.69-6.14-13.69-13.69v-6.57C0 6.14 6.14 0 13.69 0h6.57c7.55 0 13.69 6.14 13.69 13.69Zm-16.22 2.34v-4.86c1.43.18 2.7.6 2.99.78.35.22.81.11 1.03-.24s.12-.81-.23-1.03c-.43-.27-2.02-.82-3.79-1.02V6.92c0-.41-.34-.75-.75-.75s-.75.34-.75.75V9.6c-.91.02-1.79.18-2.55.54-1.23.6-1.95 1.67-2.1 3.11-.29 2.8 2.36 3.57 4.64 4.02v5.21c-1.65-.24-3.18-.81-3.49-1.02a.74.74 0 0 0-1.04.19c-.24.34-.15.81.19 1.04.48.33 2.33 1.05 4.34 1.3v2.61c0 .41.34.75.75.75s.75-.34.75-.75v-2.52c.86-.01 1.69-.15 2.41-.47 1.28-.58 2.04-1.68 2.22-3.17.37-3.19-2.64-4.01-4.63-4.41Z",
    fill: "#fff"
  }))));
};
export default SvgNavFinanzasWhite;